import * as utils from "../utils/utils.js";

export default function Help() {

  const onClick = () => {
    utils.clearStorage();
  }

  return (
    <div>
        <h1>MOT MOT MOTUS</h1>
        <p>
          Si vous rencontrez des problèmes, veuillez me contacter à cette adresse : contact@zestudio.net
        </p>
        <p>
          Si votre partie est bloquée pour une raison inexpliquée, cliquez sur le bouton ci-dessous pour demander un nouveau mot.
        </p>
        <button onClick={() => onClick()}>Débloquer</button>
    </div>
  );
}